// import React from 'react'

// Hooks
import { useGlobal, useParams } from '../../hooks'

// Components
// import TeckCda from '../../components/Teck/Cda'
// import TeckCda2 from '../../components/Teck/Cda2'
// import TeckCda3 from '../../components/Teck/Cda3'
// import TeckLaboratory from '../../components/Teck/Laboratory'
// import TeckPelambres from '../../components/Teck/Pelambres'
import PageNotFound from '../NotFound'

const PageTecks = ({ auth }) => {
  const [{ me }] = useGlobal()
  const { name } = useParams()

  switch (name) {
    // case 'cda':
    //   return <TeckCda />
    // case 'cda2':
    //   return <TeckCda2 />
    // case 'cda3':
    //   if (me.id !== 903 /* Jorge */) return <PageNotFound />
    //   return <TeckCda3 />
    // case 'laboratory':
    //   return <TeckLaboratory />
    // case 'pelambres':
    //   return <TeckPelambres />
    default:
      return <PageNotFound />
  }
}

export default PageTecks
